import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { CartContext } from "../context/CartContext";
import './ProductDetail.css';

function ProductDetail() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const { cart, addToCart } = useContext(CartContext);
  const [addToCartSuccess, setAddToCartSuccess] = useState(true);

  useEffect(() => {
    fetch(`/api/products/${productId}`)
      .then((res) => res.json())
      .then(setProduct);
  }, [productId]);

  if (!product) return <div>Loading...</div>;

  // this line of code must be after the product is fetched
  const isInCart = cart.some(item => item.id === product.id);

  const handleAddToCart = () => {
    if (!isInCart) {
      addToCart(product)
      setAddToCartSuccess(true)
    } else {
      setAddToCartSuccess(false)
    }
    setShowToast(true)
    setTimeout(() => setShowToast(false), 2000) // Hide toast after 2s
  };

  const toastMessage = () => {
    if (addToCartSuccess) {
      return "Product added to cart!";
    } else {
      return "Product is already in cart.";
    }
  }

  return (
    <div className="page-container">
      <img src={product.image} alt={product.name} style={{ maxWidth: 300 }} />
      <h2>{product.name}</h2>
      <div>{product.price}</div>
      <p>{product.description}</p>
      <button
        onClick={handleAddToCart}
      >
        Add to Cart
      </button>
      {showToast && <div className="toast">{toastMessage()}</div>}
    </div>
  );
}

export default ProductDetail;